import { store } from "@store/store";
import { removePayloadKey } from "@store/slices/globalState";

export const removePayloadKeyAction = (payload: { key: string }) => {
  const { key } = payload;
  store?.dispatch(removePayloadKey(key));
};

